module.exports = __webpack_public_path__ + "img/arrow-back-circle-outline.4eb6956d.svg";